var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "worldcup" }, [
    _c(
      "div",
      { staticClass: "cup" },
      [
        _c(
          "header",
          { style: { backgroundImage: "url(" + _vm.config.h5Banner + ")" } },
          [
            _c("div", { staticClass: "theme" }, [
              _c("div", { staticClass: "div" }, [
                _c("img", {
                  staticClass: "img",
                  attrs: {
                    src:
                      "../../static/images/" +
                      (_vm.isDirection ? "right" : "left") +
                      ".png",
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("div", [
                  _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("300194")) } })
                ]),
                _vm._v(" "),
                _c("img", {
                  attrs: {
                    src:
                      "../../static/images/" +
                      (_vm.isDirection ? "left" : "right") +
                      ".png",
                    alt: ""
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text" }, [
                _c("img", {
                  attrs: {
                    src: "../../static/images/" + _vm.language + ".png",
                    alt: ""
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "time" }, [
                _c("div", [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("300142")) +
                        ":2022/11/20 00:00 - 2022/12/18 23:00"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "rule",
                  on: {
                    click: function($event) {
                      return _vm.$router.push("/worldcuprule")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("300126")))]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("main", [
          _c("div", { staticClass: "match" }, [
            _c("div", { staticClass: "groupmacth" }, [
              _c("div", { staticClass: "tabheader" }, [
                _c(
                  "div",
                  {
                    class: { tabactive: _vm.activeind == "group" },
                    on: {
                      click: function($event) {
                        return _vm.changeTab("group")
                      }
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("300197")))])]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: { tabactive: _vm.activeind == "knockout" },
                    on: {
                      click: function($event) {
                        return _vm.changeTab("knockout")
                      }
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("300201")))])]
                )
              ]),
              _vm._v(" "),
              _vm.activeind == "group"
                ? _c("div", { staticClass: "teams" }, [
                    _c(
                      "div",
                      [
                        _c(
                          "van-tabs",
                          {
                            attrs: { "line-height": "0" },
                            on: {
                              click: function($event) {
                                return _vm.tabchange(_vm.activename)
                              }
                            },
                            model: {
                              value: _vm.activename,
                              callback: function($$v) {
                                _vm.activename = $$v
                              },
                              expression: "activename"
                            }
                          },
                          _vm._l(_vm.groupnameList, function(item, index) {
                            return _c("van-tab", {
                              key: index,
                              attrs: {
                                name: item,
                                title: _vm.$t("300198", { num: item })
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.groupmsg[_vm.active]
                      ? _c(
                          "div",
                          { staticClass: "teamslist" },
                          _vm._l(_vm.groupList[_vm.activename], function(
                            item,
                            index
                          ) {
                            return _c("dl", { key: index }, [
                              _c(
                                "dt",
                                {
                                  class: [
                                    _vm.groupmsg[_vm.active].gameStatus != 2
                                      ? "light"
                                      : "dark"
                                  ]
                                },
                                [
                                  _c("img", {
                                    attrs: { src: item.icon, alt: "" }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "reward" }, [
                                    _c("p", [
                                      _vm._v(_vm._s(item[_vm.language]))
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("300199", {
                                            num: parseInt(
                                              _vm.groupmsg[_vm.active].teams[
                                                index
                                              ].amount
                                            )
                                          })
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _vm.groupmsg[_vm.active].teams[index].isWinner
                                    ? _c("div", { staticClass: "Promotion" }, [
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.$t("300202")))
                                        ])
                                      ])
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "dd",
                                {
                                  class: [
                                    _vm.groupmsg[_vm.active].gameStatus != 2
                                      ? "light"
                                      : "dark"
                                  ],
                                  style: {
                                    backgroundImage:
                                      "url('../../static/images/" +
                                      (_vm.groupmsg[_vm.active].gameStatus != 2
                                        ? "btn_light"
                                        : "btn_dark") +
                                      ".png')"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.support(
                                        _vm.groupmsg[_vm.active].gameStatus,
                                        _vm.groupmsg[_vm.active].teams[index]
                                          .teamId
                                      )
                                    }
                                  }
                                },
                                [_c("span", [_vm._v(_vm._s(_vm.$t("300200")))])]
                              )
                            ])
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.groupmsg[_vm.active].startTime < new Date()
                      ? _c("div", [
                          !_vm.isStart
                            ? _c("div", { staticClass: "time" }, [
                                _c("div", [
                                  _c("dl", [
                                    _c("dt", [
                                      _vm._v(_vm._s(_vm.$t("300212")))
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", [_vm._v("00")])
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(":")]),
                                  _vm._v(" "),
                                  _c("dl", [
                                    _c("dt", [
                                      _vm._v(_vm._s(_vm.$t("300213")))
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", [_vm._v("00")])
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(":")]),
                                  _vm._v(" "),
                                  _c("dl", [
                                    _c("dt", [
                                      _vm._v(_vm._s(_vm.$t("300214")))
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", [_vm._v("00")])
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(":")]),
                                  _vm._v(" "),
                                  _c("dl", [
                                    _c("dt", [
                                      _vm._v(_vm._s(_vm.$t("300215")))
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", [_vm._v("00")])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("p", [_vm._v(_vm._s(_vm.$t("300203")))])
                              ])
                            : _c("div", { staticClass: "time" }, [
                                _c("div", [
                                  _c("dl", [
                                    _c("dt", [
                                      _vm._v(_vm._s(_vm.$t("300212")))
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", [_vm._v(_vm._s(_vm.time.day))])
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(":")]),
                                  _vm._v(" "),
                                  _c("dl", [
                                    _c("dt", [
                                      _vm._v(_vm._s(_vm.$t("300213")))
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", [_vm._v(_vm._s(_vm.time.hours))])
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(":")]),
                                  _vm._v(" "),
                                  _c("dl", [
                                    _c("dt", [
                                      _vm._v(_vm._s(_vm.$t("300214")))
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", [_vm._v(_vm._s(_vm.time.minutes))])
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(":")]),
                                  _vm._v(" "),
                                  _c("dl", [
                                    _c("dt", [
                                      _vm._v(_vm._s(_vm.$t("300215")))
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", [_vm._v(_vm._s(_vm.time.second))])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("p", [_vm._v(_vm._s(_vm.$t("300203")))])
                              ])
                        ])
                      : _vm._e()
                  ])
                : _c(
                    "div",
                    { staticClass: "knockout" },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "van-tabs",
                            {
                              attrs: { "line-height": "0" },
                              on: { click: _vm.changeType },
                              model: {
                                value: _vm.knockoutActive,
                                callback: function($$v) {
                                  _vm.knockoutActive = $$v
                                },
                                expression: "knockoutActive"
                              }
                            },
                            [
                              _vm._l(_vm.optionList, function(item, index) {
                                return _c("van-tab", {
                                  key: index + "A",
                                  attrs: {
                                    name: item.value,
                                    title: _vm.$t(item.label)
                                  }
                                })
                              }),
                              _vm._v(" "),
                              _c("van-tab", { attrs: { name: "", title: "" } })
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.eliminList.length > 0
                        ? _c("div", { staticClass: "knockout-container" }, [
                            _vm.activeObj
                              ? _c("div", { staticClass: "flex-between" }, [
                                  _c("div", { staticClass: "left-icon" }, [
                                    _c("span", { staticClass: "block icon" }, [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.teamIconFilter(
                                            _vm.activeObj.teams[0].teamId
                                          ),
                                          alt: ""
                                        }
                                      })
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "flex-between team-name" },
                                    [
                                      _c("span", { staticClass: "bold" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.teamsListFilter(
                                              _vm.activeObj.teams[0].teamId
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "bold" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.teamsListFilter(
                                              _vm.activeObj.teams[1].teamId
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "right-icon" }, [
                                    _c("span", { staticClass: "block icon" }, [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.teamIconFilter(
                                            _vm.activeObj.teams[1].teamId
                                          ),
                                          alt: ""
                                        }
                                      })
                                    ])
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.activeObj
                              ? _c("div", { staticClass: "flex-between" }, [
                                  _c("div", { staticClass: "text" }, [
                                    _vm.activeObj.gameStatus != 2
                                      ? _c(
                                          "span",
                                          { staticClass: "block bold" },
                                          [_vm._v("?")]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "block bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.activeObj.teams[0].isWinner
                                                  ? _vm.$t("300228")
                                                  : _vm.$t("300229")
                                              )
                                            )
                                          ]
                                        )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "text" }, [
                                    _vm.activeObj.gameStatus != 2
                                      ? _c(
                                          "span",
                                          { staticClass: "block bold" },
                                          [_vm._v("?")]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "block bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.activeObj.teams[1].isWinner
                                                  ? _vm.$t("300228")
                                                  : _vm.$t("300229")
                                              )
                                            )
                                          ]
                                        )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.activeObj
                              ? _c("div", { staticClass: "total-amount" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("300230", {
                                          num: _vm.accAdd(
                                            _vm.activeObj.teams[0].amount,
                                            _vm.activeObj.teams[1].amount
                                          )
                                        })
                                      ) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.activeObj
                              ? _c("div", { staticClass: "flex-between" }, [
                                  _c("div", { staticClass: "buttons" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "block bold flex-center button",
                                        class: [
                                          _vm.activeObj.gameStatus != 2
                                            ? "light"
                                            : "dark"
                                        ],
                                        style: {
                                          backgroundImage:
                                            "url(../../static/images/" +
                                            (_vm.activeObj.gameStatus != 2
                                              ? "btn_light"
                                              : "btn_dark") +
                                            ".png)"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.supportCopy(
                                              _vm.activeObj,
                                              _vm.activeObj.teams[0].teamId
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("300200")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "block amount" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.activeObj.teams[0].amount
                                          ) + " ET"
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "buttons" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "block bold flex-center button",
                                        class: [
                                          _vm.activeObj.gameStatus != 2
                                            ? "light"
                                            : "dark"
                                        ],
                                        style: {
                                          backgroundImage:
                                            "url(../../static/images/" +
                                            (_vm.activeObj.gameStatus != 2
                                              ? "btn_light"
                                              : "btn_dark") +
                                            ".png)"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.supportCopy(
                                              _vm.activeObj,
                                              _vm.activeObj.teams[1].teamId
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("300200")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "block amount" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.activeObj.teams[1].amount
                                          ) + " ET"
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.activeObj &&
                            _vm.activeObj.startTime < new Date()
                              ? _c("div", [
                                  !_vm.isStartCopy
                                    ? _c("div", { staticClass: "time" }, [
                                        _c("div", [
                                          _c("dl", [
                                            _c("dt", [
                                              _vm._v(_vm._s(_vm.$t("300212")))
                                            ]),
                                            _vm._v(" "),
                                            _c("dd", [_vm._v("00")])
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [_vm._v(":")]),
                                          _vm._v(" "),
                                          _c("dl", [
                                            _c("dt", [
                                              _vm._v(_vm._s(_vm.$t("300213")))
                                            ]),
                                            _vm._v(" "),
                                            _c("dd", [_vm._v("00")])
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [_vm._v(":")]),
                                          _vm._v(" "),
                                          _c("dl", [
                                            _c("dt", [
                                              _vm._v(_vm._s(_vm.$t("300214")))
                                            ]),
                                            _vm._v(" "),
                                            _c("dd", [_vm._v("00")])
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [_vm._v(":")]),
                                          _vm._v(" "),
                                          _c("dl", [
                                            _c("dt", [
                                              _vm._v(_vm._s(_vm.$t("300215")))
                                            ]),
                                            _vm._v(" "),
                                            _c("dd", [_vm._v("00")])
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(_vm._s(_vm.$t("300203")))
                                        ])
                                      ])
                                    : _c("div", { staticClass: "time" }, [
                                        _c("div", [
                                          _c("dl", [
                                            _c("dt", [
                                              _vm._v(_vm._s(_vm.$t("300212")))
                                            ]),
                                            _vm._v(" "),
                                            _c("dd", [
                                              _vm._v(_vm._s(_vm.timeCopy.day))
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [_vm._v(":")]),
                                          _vm._v(" "),
                                          _c("dl", [
                                            _c("dt", [
                                              _vm._v(_vm._s(_vm.$t("300213")))
                                            ]),
                                            _vm._v(" "),
                                            _c("dd", [
                                              _vm._v(_vm._s(_vm.timeCopy.hours))
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [_vm._v(":")]),
                                          _vm._v(" "),
                                          _c("dl", [
                                            _c("dt", [
                                              _vm._v(_vm._s(_vm.$t("300214")))
                                            ]),
                                            _vm._v(" "),
                                            _c("dd", [
                                              _vm._v(
                                                _vm._s(_vm.timeCopy.minutes)
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [_vm._v(":")]),
                                          _vm._v(" "),
                                          _c("dl", [
                                            _c("dt", [
                                              _vm._v(_vm._s(_vm.$t("300215")))
                                            ]),
                                            _vm._v(" "),
                                            _c("dd", [
                                              _vm._v(
                                                _vm._s(_vm.timeCopy.second)
                                              )
                                            ])
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(_vm._s(_vm.$t("300203")))
                                        ])
                                      ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.activeObj
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "view-more",
                                    on: {
                                      click: function($event) {
                                        _vm.teamsDialog = true
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("300231")) + " >")]
                                )
                              : _vm._e()
                          ])
                        : _c(
                            "van-empty",
                            { attrs: { description: _vm.$t("300193") } },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "icon empty-icon",
                                  attrs: {
                                    slot: "image",
                                    "aria-hidden": "true"
                                  },
                                  slot: "image"
                                },
                                [
                                  _c("use", {
                                    attrs: { "xlink:href": "#icon-zanwu" }
                                  })
                                ]
                              )
                            ]
                          )
                    ],
                    1
                  )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "history" }, [
              _c("header", [
                _c("div", [
                  _c("img", {
                    attrs: {
                      src: require("../../static/images/line.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" " + _vm._s(_vm.$t("300196")) + " "),
                  _c("img", {
                    attrs: {
                      src: require("../../static/images/line.png"),
                      alt: ""
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _vm.historyList.length > 0
                ? _c(
                    "div",
                    { staticClass: "historylist" },
                    [
                      _c(
                        "van-list",
                        {
                          attrs: {
                            finished: _vm.finished,
                            "finished-text": " ",
                            "loading-text": " "
                          },
                          on: { load: _vm.onLoad },
                          model: {
                            value: _vm.loading,
                            callback: function($$v) {
                              _vm.loading = $$v
                            },
                            expression: "loading"
                          }
                        },
                        _vm._l(_vm.historyList, function(item, index) {
                          return _c("ul", { key: index }, [
                            _c("li", [
                              _c("span", [_vm._v(_vm._s(_vm.$t("300207")))]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.parseTime(
                                      item.createTime,
                                      "{y}/{m}/{d} {h}:{i}:{s}"
                                    )
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("span", [_vm._v(_vm._s(_vm.$t("300216")))]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.fixteams(item.type)))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("span", [_vm._v(_vm._s(_vm.$t("300208")))]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.teamsListFilter(item.teamId)))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("span", [_vm._v(_vm._s(_vm.$t("300209")))]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(item.betAmount) + " ET")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("span", [_vm._v(_vm._s(_vm.$t("300210")))]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    item.winner
                                      ? item.winningAmount + " ET"
                                      : "--"
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("span", [_vm._v(_vm._s(_vm.$t("300211")))]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    item.winner
                                      ? _vm.winteams(item.winner, item.name)
                                      : "--"
                                  )
                                )
                              ])
                            ])
                          ])
                        }),
                        0
                      )
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "historyno" },
                    [
                      _c(
                        "van-empty",
                        { attrs: { description: _vm.$t("300108") } },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "icon empty-icon",
                              attrs: { slot: "image", "aria-hidden": "true" },
                              slot: "image"
                            },
                            [
                              _c("use", {
                                attrs: { "xlink:href": "#icon-zanwu" }
                              })
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "van-popup",
          {
            attrs: { "close-on-click-overlay": false },
            model: {
              value: _vm.notdata,
              callback: function($$v) {
                _vm.notdata = $$v
              },
              expression: "notdata"
            }
          },
          [
            _c(
              "div",
              { staticClass: "notdata" },
              [
                _c("p", [
                  _c("i", {
                    staticClass: "iconfont icon-guanbi1",
                    on: {
                      click: function($event) {
                        _vm.notdata = false
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "warning" }, [
                  _c("svg", [
                    _c("use", { attrs: { "xlink:href": "#icon-tishi-1" } })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cannot" }, [
                  _vm._v(_vm._s(_vm.$t("300217")))
                ]),
                _vm._v(" "),
                _c(
                  "van-button",
                  {
                    on: {
                      click: function($event) {
                        _vm.notdata = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("300219")))]
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "van-popup",
          {
            attrs: { duration: 0, "close-on-click-overlay": false },
            model: {
              value: _vm.supportdialog,
              callback: function($$v) {
                _vm.supportdialog = $$v
              },
              expression: "supportdialog"
            }
          },
          [
            _c("div", { staticClass: "vote" }, [
              _c("p", [
                _c("span", [_vm._v(_vm._s(_vm.$t("300204")))]),
                _vm._v(" "),
                _c("i", {
                  staticClass: "iconfont icon-guanbi1",
                  on: {
                    click: function($event) {
                      _vm.supportdialog = false
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("300220")))]),
                _vm._v(" "),
                _c("div", { staticClass: "inputET" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputval,
                        expression: "inputval"
                      }
                    ],
                    attrs: { placeholder: _vm.$t("300205"), type: "text" },
                    domProps: { value: _vm.inputval },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.inputval = $event.target.value
                        },
                        function($event) {
                          return _vm.numberFn(_vm.inputval)
                        }
                      ],
                      blur: _vm.blur
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("ET")])
                ])
              ]),
              _vm._v(" "),
              _vm.amount
                ? _c("p", { staticClass: "mincount" }, [
                    _vm._v(
                      _vm._s(_vm.$t("300206", { num: _vm.config.minAmount }))
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.amount && _vm.inputval * 1 > _vm.user.available * 1
                ? _c("p", { staticClass: "price" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.$t("300221")) + "\n          "
                    ),
                    _c("span", { on: { click: _vm.Recharge } }, [
                      _vm._v(_vm._s(_vm.$t("300222")))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn" },
                [
                  _c(
                    "van-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.supportdialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("300111")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "van-button",
                    { staticClass: "activebtn", on: { click: _vm.Betting } },
                    [_vm._v(_vm._s(_vm.$t("300219")))]
                  )
                ],
                1
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "van-popup",
          {
            staticClass: "teams-popup",
            style: { height: "70%" },
            attrs: {
              "close-on-click-overlay": false,
              position: "bottom",
              round: ""
            },
            model: {
              value: _vm.teamsDialog,
              callback: function($$v) {
                _vm.teamsDialog = $$v
              },
              expression: "teamsDialog"
            }
          },
          [
            _c("p", { staticClass: "title flex-between bold" }, [
              _vm._v(_vm._s(_vm.$t("300232")) + " "),
              _c("i", {
                staticClass: "iconfont icon-guanbi1",
                on: {
                  click: function($event) {
                    _vm.teamsDialog = false
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { attrs: { type: "none" } },
              _vm._l(_vm.eliminList, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index + "B",
                    staticClass: "item flex-between",
                    on: {
                      click: function($event) {
                        return _vm.handleClick(item)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.teamIconFilter(item.teams[0].teamId),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "inline-block" }, [
                      _vm._v(
                        _vm._s(_vm.teamsListFilter(item.teams[0].teamId)) + " "
                      ),
                      _c("em", { staticClass: "normal bold inline-block" }, [
                        _vm._v("VS")
                      ]),
                      _vm._v(
                        " " + _vm._s(_vm.teamsListFilter(item.teams[1].teamId))
                      )
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: _vm.teamIconFilter(item.teams[1].teamId),
                        alt: ""
                      }
                    })
                  ]
                )
              }),
              0
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-951a30e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-951a30e6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/worldcup.vue
// module id = zibq
// module chunks = 0